module.exports = __webpack_public_path__ + "static/media/la-cover.2e5a8ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-cover.jpg
// module id = 59
// module chunks = 0